var _style, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgEnglishFlag(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 6422.8 4281.9",
    style: {
      enableBackground: "new 0 0 6422.8 4281.9"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#00247D;}\n\t.st1{fill:#FFFFFF;}\n\t.st2{fill:#CF142B;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "0,2854.6 0,3836.2 1472.4,2854.6  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "5754.3,0 3925,0 3925,1219.5  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "668.5,4281.9 2497.8,4281.9 2497.8,3062.4  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "0,445.7 0,1427.3 1472.4,1427.3  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "2497.8,0 668.5,0 2497.8,1219.5  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "6422.8,3836.2 6422.8,2854.6 4950.4,2854.6  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "6422.8,1427.3 6422.8,445.7 4950.4,1427.3  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "3925,4281.9 5754.3,4281.9 3925,3062.4  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "2497.8,1427.3 2497.8,1219.5 668.5,0 0,0 2140.9,1427.3  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "1695.3,1427.3 0,297.1 0,445.7 1472.4,1427.3  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "3925,2854.6 3925,3062.4 5754.3,4281.9 6422.8,4281.9 4281.9,2854.6  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "2497.8,2913.8 445.7,4281.9 668.5,4281.9 2497.8,3062.4  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "1472.4,2854.6 0,3836.2 0,4281.9 2140.9,2854.6  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "4727.5,2854.6 6422.8,3984.8 6422.8,3836.2 4950.4,2854.6  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "4950.4,1427.3 6422.8,445.7 6422.8,0 4281.9,1427.3  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "3925,1368.1 5977.1,0 5754.3,0 3925,1219.5  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st2",
    points: "2140.9,1427.3 0,0 0,297.1 1695.3,1427.3  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st2",
    points: "4727.5,2854.6 4281.9,2854.6 6422.8,4281.9 6422.8,3984.8  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st2",
    points: "2497.8,2854.6 2140.9,2854.6 0,4281.9 445.7,4281.9 2497.8,2913.8  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st2",
    points: "3925,1427.3 4281.9,1427.3 6422.8,0 5977.1,0 3925,1368.1  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "3639.6,1712.7 6422.8,1712.7 6422.8,1427.3 4950.4,1427.3 4281.9,1427.3 3925,1427.3 3925,1368.1  3925,1219.5 3925,0 3639.6,0  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "3925,2854.6 4281.9,2854.6 4727.5,2854.6 4950.4,2854.6 6422.8,2854.6 6422.8,2569.1 3639.6,2569.1  3639.6,4281.9 3925,4281.9 3925,3062.4  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "2783.2,2569.1 0,2569.1 0,2854.6 1472.4,2854.6 2140.9,2854.6 2497.8,2854.6 2497.8,2913.8  2497.8,3062.4 2497.8,4281.9 2783.2,4281.9  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "2783.2,1712.7 2783.2,0 2497.8,0 2497.8,1219.5 2497.8,1427.3 2140.9,1427.3 1695.3,1427.3  1472.4,1427.3 0,1427.3 0,1712.7  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st2",
    points: "3639.6,2569.1 6422.8,2569.1 6422.8,2140.9 6422.8,1712.7 3639.6,1712.7 3639.6,0 3211.4,0 2783.2,0  2783.2,1712.7 0,1712.7 0,2140.9 0,2569.1 2783.2,2569.1 2783.2,4281.9 3211.4,4281.9 3639.6,4281.9  "
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEnglishFlag);
export default __webpack_public_path__ + "static/media/EnglishFlag.0c603cd52e05f3521ab64a98a61e2cdb.svg";
export { ForwardRef as ReactComponent };